import axios from 'axios';

const integrationsHttp = axios.create({
  baseURL: process.env.VUE_APP_INTEGRATIONS_DOMAIN,
  timeout: 30000,
});

export default integrationsHttp;
